"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _reduxForm = require("redux-form");
var _get = _interopRequireDefault(require("lodash/get"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _userActions = require("../../redux/actions/userActions");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Enable2FAForm = _interopRequireDefault(require("./Enable2FAForm"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _history = _interopRequireDefault(require("../../helpers/history"));
require("./Enable2FAModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StandaloneEnable2FAModal = /*#__PURE__*/function (_React$Component) {
  function StandaloneEnable2FAModal() {
    var _this;
    _classCallCheck(this, StandaloneEnable2FAModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StandaloneEnable2FAModal, [].concat(args));
    _defineProperty(_this, "handleClose", function (event) {
      var close = _this.props.close;
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      close();
      if (event) {
        _history["default"].goBack();
      }
    });
    return _this;
  }
  _inherits(StandaloneEnable2FAModal, _React$Component);
  return _createClass(StandaloneEnable2FAModal, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        GoogleQRCode = _this$props.GoogleQRCode,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        userName = _this$props.userName,
        Use2FAEnabled = _this$props.Use2FAEnabled;
      if (Use2FAEnabled) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouter.Redirect, {
          to: "/login"
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        isOpen: true,
        title: t("Enable Two-Factor Authentication"),
        close: this.handleClose
      }, /*#__PURE__*/_react["default"].createElement(_Enable2FAForm["default"], {
        userName: userName,
        GoogleQRCode: GoogleQRCode,
        handleSubmit: handleSubmit,
        submitting: submitting
      }));
    }
  }]);
}(_react["default"].Component);
StandaloneEnable2FAModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
StandaloneEnable2FAModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    GoogleQRCode: state.user.qrCode.ManualCode,
    userName: (0, _get["default"])(state, 'auth.creds.username', false),
    Use2FAEnabled: state.user.userInfo.Use2FA
  };
};
var mapDispatchToProps = {
  changeFieldValue: _reduxForm.change,
  getGoogleQrCode: _userActions.getGoogleQrCode
};
var containerForm = (0, _reduxForm.reduxForm)({
  form: 'forceEnable2FAModal',
  onSubmit: function onSubmit(payload, dispatch) {
    dispatch((0, _userActions.enable2FA)(payload.code, true)).then(function (res) {
      console.log(res);
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(StandaloneEnable2FAModal);
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(containerForm);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('auth')((0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.ENABLE_2FA
})(container));